var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Set-Strategy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.699999988
  }, /*#__PURE__*/React.createElement("g", {
    id: "Strategy-Final-|-Player-Dragging-(Desktop)",
    transform: "translate(-19.000000, -484.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(0.000000, 46.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy-7",
    transform: "translate(0.000000, 422.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(16.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Store",
    transform: "translate(3.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Store-(Background/Mask)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25,20.1666667 C7.74373895,20.1666667 7.33333333,19.756261 7.33333333,19.25 C7.33333333,18.743739 7.74373895,18.3333333 8.25,18.3333333 C8.75626105,18.3333333 9.16666667,18.743739 9.16666667,19.25 C9.16666667,19.756261 8.75626105,20.1666667 8.25,20.1666667 Z",
    id: "Vector",
    stroke: "#FFFFFF",
    strokeWidth: 1.6,
    fill: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3333333,20.1666667 C17.8270723,20.1666667 17.4166667,19.756261 17.4166667,19.25 C17.4166667,18.743739 17.8270723,18.3333333 18.3333333,18.3333333 C18.8395944,18.3333333 19.25,18.743739 19.25,19.25 C19.25,19.756261 18.8395944,20.1666667 18.3333333,20.1666667 Z",
    id: "Vector",
    stroke: "#FFFFFF",
    strokeWidth: 1.6,
    fill: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.916666667,0.916666667 L4.58333333,0.916666667 L7.03999984,13.1908336 C7.12382409,13.6128625 7.35341574,13.9919633 7.68858345,14.2617733 C8.02375117,14.5315833 8.4431396,14.6749108 8.87333361,14.6666667 L17.783333,14.6666667 C18.213527,14.6749108 18.6329163,14.5315833 18.968084,14.2617733 C19.3032517,13.9919633 19.5328421,13.6128625 19.6166663,13.1908336 L21.0833333,5.5 L5.5,5.5",
    id: "Vector",
    stroke: "#FFFFFF",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStore);
export default __webpack_public_path__ + "static/media/Store.b8abf3e4bd65c18e2839efd3ce14a01e.svg";
export { ForwardRef as ReactComponent };